import React, { useState } from 'react';
import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ModalBody,
    ModalCloseButton,
    Button,
    FormControl,
    FormLabel,
    Input,
    Select,
    useDisclosure,
    useToast,
} from '@chakra-ui/react';
import axios from 'axios';

const AddAssetModal = ({ onAssetAdded }) => {
    const { isOpen, onOpen, onClose } = useDisclosure();
    const [ticker, setTicker] = useState('');
    const [isin, setIsin] = useState('');
    const [name, setName] = useState('');
    const [broker, setBroker] = useState('');
    const [currency, setCurrency] = useState('EUR');
    const [type, setType] = useState('');
    const toast = useToast();

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        try {
            const token = localStorage.getItem('token');
            await axios.post(
                '/api/assets',
                { ticker: ticker, name: name, broker: broker, currency: currency, type: type },
                { headers: { Authorization: `Bearer ${token}` } }
            );
            toast({
                title: 'Asset created.',
                description: 'The asset has been created successfully.',
                status: 'success',
                duration: 5000,
                isClosable: true,
            }); 
            onClose();
            onAssetAdded();
        } catch (error) {
            toast({
                title: 'Error creating asset.',
                description: 'There was an error creating the asset.',
                status: 'error',
                duration: 5000,
                isClosable: true,
            });
        }
    };

    return (
        <>
            <Button onClick={onOpen} colorScheme="teal" mb={4}>
                Add Asset
            </Button>

            <Modal isOpen={isOpen} onClose={onClose}>
                <ModalOverlay />
                <ModalContent>
                    <form onSubmit={handleSubmit}>
                        <ModalHeader>Add New Asset</ModalHeader>
                        <ModalCloseButton />
                        <ModalBody>
                            <FormControl id="ticker">
                                <FormLabel>Ticker</FormLabel>
                                <Input value={ticker} onChange={(e) => setTicker(e.target.value)} />
                            </FormControl>
                            <FormControl id="isin" mt={4}>
                                <FormLabel>ISIN</FormLabel>
                                <Input value={isin} onChange={(e) => setIsin(e.target.value)} />
                            </FormControl>
                            <FormControl id="name" isRequired mt={4}>
                                <FormLabel>Name</FormLabel>
                                <Input value={name} onChange={(e) => setName(e.target.value)} />
                            </FormControl>
                            <FormControl id="type" isRequired mt={4}>
                                <FormLabel>Type</FormLabel>
                                <Input value={type} onChange={(e) => setType(e.target.value)} />
                            </FormControl>
                            <FormControl id="broker" isRequired mt={4}>
                                <FormLabel>Broker</FormLabel>
                                <Input value={broker} onChange={(e) => setBroker(e.target.value)} />
                            </FormControl>
                            <FormControl id="currency" isRequired mt={4}>
                                <FormLabel>Currency</FormLabel>
                                {/* <Input value={currency} onChange={(e) => setCurrency(e.target.value)} /> */}
                                <Select value={currency} onChange={(e) => setCurrency(e.target.value)} >
                                    <option value="EUR">EUR</option>
                                    <option value="USD">USD</option>
                                    <option value="GBP">GBP</option>
                                </Select>
                            </FormControl>
                        </ModalBody>
                        <ModalFooter>
                            <Button colorScheme="teal" mr={3} type="submit">
                                Save
                            </Button>
                            <Button variant="ghost" onClick={onClose}>
                                Cancel
                            </Button>
                        </ModalFooter>
                    </form>
                </ModalContent>
            </Modal>
        </>
    );
};

export default AddAssetModal;